<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "KS2",
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Noto+Sans+SC:wght@400;500;600;700&display=swap");
</style>
